export const UPDATE_FILTER_DETAILS = "UPDATE_FILTER_DETAILS";
